import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=12af8971&"
import script from "./ViewForm.vue?vue&type=script&lang=js&"
export * from "./ViewForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports